/*
 OK FBI — Route wrapper enforcing the OWNER admin-unlock second-stage lock.

 Even for OWNER-only routes we hit /api/owner/admin/status; if the admin
 session isn't unlocked (or admin password isn't configured yet) we redirect
 to /host which shows the unlock/setup card.

 This is a UX wrapper. The BACKEND is the real gate — every sensitive OWNER
 endpoint is separately protected by _require_owner_admin_unlocked.
*/
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Shell } from "@/components/Shell";
import { Loader2 } from "lucide-react";

export default function AdminUnlockedRoute({ children }) {
  const [state, setState] = useState("loading");   // loading | ok | locked | error
  useEffect(() => {
    let mounted = true;
    api.get("/owner/admin/status")
      .then(({ data }) => {
        if (!mounted) return;
        if (data?.unlocked) setState("ok");
        else setState("locked");
      })
      .catch((e) => {
        if (!mounted) return;
        setState(e?.response?.status === 403 ? "error" : "locked");
      });
    return () => { mounted = false; };
  }, []);

  if (state === "loading") {
    return (
      <Shell>
        <div className="p-10 text-center text-neutral-400" dir="rtl">
          <Loader2 className="inline animate-spin ms-2" size={16}/>جارٍ التحقق من فتح مركز المالك…
        </div>
      </Shell>
    );
  }
  if (state === "ok") return children;
  // locked or error → send them to the hub which will render the setup/unlock card.
  return <Navigate to="/host" replace />;
}
